module.exports = __webpack_public_path__ + "img/375_leuco_intro_img4.01305e49.png";